import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wallet, ShieldCheck, Banknote } from "lucide-react";
import { api, formatDate, rupiah } from "@/lib/api";
import { PageLoader } from "@/components/layout/RequireAuth";
import { EmptyState } from "@/pages/CategoryPage";

const PAYOUT = { ditahan: "Dana Ditahan", siap_dicairkan: "Siap Dicairkan", dicairkan: "Sudah Dicairkan" };
const CARDS = [["ditahan", ShieldCheck, "bg-sky-50 text-sky-700"], ["siap_dicairkan", Wallet, "bg-emerald-50 text-emerald-700"], ["dicairkan", Banknote, "bg-stone-100 text-stone-600"]];

export default function Earnings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/provider/earnings").then((r) => setData(r.data)); }, []);
  if (!data) return <PageLoader />;

  return (
    <div className="container-page max-w-5xl py-10 lg:py-14" data-testid="earnings-page">
      <p className="eyebrow">Penyedia</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Penghasilan</h1>
      <div className="mt-8 grid gap-4 sm:grid-cols-3">
        {CARDS.map(([k, Icon, cls]) => (
          <div key={k} className="card-soft p-6" data-testid={`earnings-total-${k}`}>
            <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${cls}`}><Icon className="h-5 w-5" /></span>
            <p className="mt-4 text-sm text-stone-500">{PAYOUT[k]}</p>
            <p className="text-2xl font-extrabold text-stone-900" data-testid={`earnings-value-${k}`}>{rupiah(data.totals[k])}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-stone-500">Pencairan dana diproses oleh admin Tuntas (segera hadir).</p>
      <h2 className="mt-10 text-lg font-bold text-stone-900">Transaksi</h2>
      <div className="mt-4">
        {data.transactions.length === 0 ? <EmptyState testId="earnings-empty" title="Belum ada transaksi" /> : (
          <div className="card-soft divide-y divide-stone-100 overflow-x-auto" data-testid="earnings-transactions">
            {data.transactions.map((t) => (
              <Link key={t.transaction_id} to={`/pesanan/${t.order_id}`} className="grid min-w-[640px] grid-cols-[1.5fr_1fr_1fr_1fr_1fr] items-center gap-3 px-6 py-4 text-sm hover:bg-stone-50" data-testid={`transaction-${t.transaction_id}`}>
                <div><p className="font-semibold text-stone-900">{t.title}</p><p className="text-xs text-stone-500">{formatDate(t.created_at)}</p></div>
                <span className="text-stone-700">{rupiah(t.gross)}</span>
                <span className="text-stone-500">- {rupiah(t.commission)} ({t.commission_percent}%)</span>
                <span className="font-bold text-stone-900">{rupiah(t.provider_net)}</span>
                <span className="text-xs font-semibold text-stone-600">{PAYOUT[t.payout_status]}</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
